module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-group",
    attrs: {
      "id": "accordion"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "panel box",
      class: ("box-" + (item.type))
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h4', {
      staticClass: "box-title"
    }, [_c('a', {
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion",
        "href": ("#" + (item.id))
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      class: index == 0 ? 'in' : '',
      attrs: {
        "id": item.id
      }
    }, [_c('div', {
      staticClass: "box-body"
    }, [_vm._v("\n        " + _vm._s(item.content) + "\n      ")])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f8e08c7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAAccordion.vue
// module id = 545
// module chunks = 1